const aboutTranslations = {
  en: {
    hero: {
      headline: 'The platform for outdoor freaks',
      subline: 'Plan, track, and share your adventures with a community that lives for the outdoors.',
      register: 'Join Free',
      login: 'Log In',
    },
    news: {
      heading: 'Latest news',
      badge: 'New',
      showMore: 'Show more',
      showLess: 'Show less',
      theFreaks: {
        context: 'Game',
        title: 'The Freaks — now on the web',
        description: 'The daily Freakland game is here: do your activity\'s missions, train, gear up, build a base, challenge other freaks and climb the Top Freaks board. Claim the daily prize and win real Freak Points. Play on the web or in the app — your progress is the same everywhere.',
        cta: 'Play The Freaks',
      },
      fishingRadar: {
        context: 'Fishing',
        title: 'Fishing Radar',
        description: 'See where the fish are biting across the country. In the Fishing context, open the radar for a daily bite-activity forecast by region on the map.',
        cta: 'Open Fishing Radar',
      },
      mushroomRadar: {
        context: 'Mushroom',
        title: 'Mushroom Radar',
        description: 'Check where mushrooms are showing up across the country. In the Mushroom context, open the radar to see the latest regional occurrence data on the map.',
        cta: 'Open Mushroom Radar',
      },
      fishing: {
        context: 'Fishing',
        title: 'Fishing spots, upgraded',
        description: 'Bite prediction, your catch log, and live weather — now built into every fishing place. Pick a feature to jump straight in.',
        prediction: 'Prediction',
        catches: 'Catches',
        weather: 'Weather',
      },
    },
    features: {
      heading: 'What can you do?',
      freaks: { title: 'Freaks', description: 'Create and join outdoor events — plan, track, and share your adventures.' },
      places: { title: 'Places', description: 'Discover and save off-road spots, fishing locations, ski resorts, and more.' },
      hub: { title: 'FreakHub', description: 'Join or create community groups centred around your favourite activities.' },
      tracker: { title: 'GPS Tracker', description: 'Record routes with live stats: distance, speed, altitude, calories, and heart rate.' },
      shake: { title: 'Shake It', description: 'Shake your device once a day for a chance to win prizes.' },
      campaigns: { title: 'Campaigns', description: 'Participate in partner events and branded outdoor competitions.' },
      theFreaks: { title: 'The Freaks', description: 'A daily game for your activity: missions, challenges, a daily prize and the Top Freaks board — on the web and in the app.' },
    },
    contexts: {
      heading: 'One app, 25+ activities',
      subline: 'Switch context instantly and stay focused on what you love.',
      list: [
        'Wild Off Road', 'Bikes', 'Fishing', 'Trip', 'Fit', 'Running', 'Pets', 'Games',
        'Books', 'Food', 'Shopping', 'Tech', 'Motorization', 'Gardening', 'Music', 'Sport',
        'Winter Sports', 'Horse Riding', 'Movies', 'Series', 'Skateboard', 'Inline Skate',
        'Scooter', 'BMX', 'Mushroom', 'Nordic Walking',
      ],
    },
    social: {
      heading: 'A community built around passion',
      follow: 'Follow & be followed',
      react: 'Like & comment on Freaks',
      chat: 'Real-time chat',
      notifications: 'Push notifications',
      leaderboard: 'Top Freaks leaderboard',
    },
    platforms: {
      heading: 'Available everywhere',
      web: 'Web',
      mobile: 'iOS & Android',
      watch: 'Apple Watch',
      watchNote: 'Work in progress',
      requestAccess: 'Request access',
    },
    explore: {
      heading: 'Curious? Explore first.',
      subline: 'No account needed — browse real public content and see what the community is creating.',
      freaks: {
        title: 'Browse Public Freaks',
        description: 'See real adventures, events, and activities shared by the Freakland community.',
        button: 'Explore Freaks',
      },
      places: {
        title: 'Discover Public Places',
        description: 'Browse community-submitted spots — trails, fishing locations, ski slopes, and more.',
        button: 'Explore Places',
      },
    },
    cta: {
      heading: 'Ready to join?',
      register: 'Create Free Account',
      loginPrompt: 'Already have an account?',
      login: 'Log in',
    },
    usersCounter: {
      label: 'Registered Adventurers',
      subline: 'and growing every day',
    },
    install: {
      heading: 'Always in your pocket',
      subline: 'Add Freakland to your home screen and launch it like a native app — no app store needed.',
      benefit1: 'Instant access from your home screen',
      benefit2: 'Full-screen experience without browser bars',
      benefit3: 'Works offline for cached content',
      benefit4: 'Push notifications for your adventures',
      iosHeading: 'iPhone & iPad',
      iosStep1: 'Open this page in Safari',
      iosStep2: 'Tap the Share icon at the bottom',
      iosStep3: 'Select "Add to Home Screen"',
      androidHeading: 'Android',
      androidStep1: 'Open this page in Chrome',
      androidStep2: 'Tap the menu (⋮) in the top right',
      androidStep3: 'Select "Add to Home screen"',
      cta: 'Add to Home Screen',
    },
    blasts: {
      heading: 'Blasts',
      subline: 'Short vertical videos attached to Freaks and places — raw moments from the trail, water, or slope, shot and shared in seconds.',
      feature1Title: 'Shot on the go',
      feature1Desc: 'Record and attach a blast directly from a Freak or place. No editing needed — just raw adventure.',
      feature2Title: 'Full-screen feed',
      feature2Desc: 'Scroll through blasts from the whole community in a TikTok-style vertical feed. Like, follow, and discover.',
      feature3Title: 'Stays with the context',
      feature3Desc: 'Every blast is linked to a specific Freak or place, so you always know where it happened.',
      cta: 'Watch Blasts',
    },
    earlyAccess: {
      heading: 'GPS Track Recording',
      chip: 'Early Access',
      subline: 'Record your routes in real time — distance, speed, altitude, and moving time. Available to selected users during the early access phase.',
      howTitle: 'How to get access',
      step1: 'Send an email to freakland.app@gmail.com',
      step2: 'Subject: "Track Access Request"',
      step3: 'Include your registered email address',
      cta: 'Request Access',
    },
    partnership: {
      heading: 'Partner with Freakland',
      subline: 'Become the recognized face of your activity context or grow your brand among thousands of passionate outdoor enthusiasts.',
      ambassador: {
        title: 'Context Ambassador',
        description: 'Are you THE person in your off-road, fishing, or cycling community? Represent your context on Freakland — get pinned on the context homepage, earn a verified badge, and grow your audience.',
        perks: [
          'Featured on context homepage',
          'Verified ambassador badge',
          'Boosted content visibility',
          'Priority placement in leaderboard',
        ],
        giftsNote: 'Ambassadors receive exclusive gifts and physical rewards over time. Check your profile page regularly to see what we have prepared for you.',
        cta: 'Apply as Ambassador',
      },
      brand: {
        title: 'Brand Partnership',
        description: 'Align your brand with an activity community. Sponsor Shake It daily prizes, run branded campaigns, list your shop, and reach a targeted outdoor audience.',
        perks: [
          'Sponsor Shake It prizes',
          'Branded campaigns & events',
          'Shop & product listing',
          'Targeted reach to your niche',
        ],
        cta: 'Talk to Us',
      },
      contactPrompt: 'Questions? Write to us:',
      feedbackPrompt: 'Got thoughts on the app?',
      feedbackLink: 'Send us feedback',
    },
    support: {
      heading: 'Enjoying Freakland?',
      subline: 'Freakland is built by a small team of outdoor freaks. If you like what we do, buy us a coffee — it keeps the servers running and the features coming.',
      cta: 'Buy me a coffee',
    },
  },
  pl: {
    hero: {
      headline: 'Platforma dla outdoor freaks',
      subline: 'Planuj, nagrywaj i dziel się przygodami ze społecznością, która żyje na świeżym powietrzu.',
      register: 'Dołącz za darmo',
      login: 'Zaloguj się',
    },
    news: {
      heading: 'Najnowsze wiadomości',
      badge: 'Nowość',
      showMore: 'Pokaż więcej',
      showLess: 'Pokaż mniej',
      theFreaks: {
        context: 'Gra',
        title: 'The Freaks — teraz w przeglądarce',
        description: 'Codzienna gra Freaklandu: wykonuj misje swojej aktywności, trenuj, kupuj sprzęt, buduj bazę, wyzywaj innych freaków i wspinaj się w rankingu Top Freaks. Odbieraj codzienną nagrodę i wygrywaj prawdziwe Freak Punkty. Graj w przeglądarce albo w aplikacji — postęp jest wszędzie ten sam.',
        cta: 'Zagraj w The Freaks',
      },
      fishingRadar: {
        context: 'Wędkarstwo',
        title: 'Radar wędkarski',
        description: 'Zobacz, gdzie w kraju biorą ryby. W kontekście „Wędkarstwo" otwórz radar, aby zobaczyć na mapie dzienną prognozę aktywności brań w regionach.',
        cta: 'Otwórz radar wędkarski',
      },
      mushroomRadar: {
        context: 'Na Grzyby',
        title: 'Radar grzybowy',
        description: 'Sprawdź, gdzie w kraju pojawiają się grzyby. W kontekście „Na Grzyby" otwórz radar, aby zobaczyć na mapie najnowsze dane o występowaniu w regionach.',
        cta: 'Otwórz radar grzybowy',
      },
      fishing: {
        context: 'Wędkarstwo',
        title: 'Łowiska w nowej odsłonie',
        description: 'Prognoza brań, dziennik połowów i pogoda na żywo — teraz w każdym łowisku. Wybierz funkcję i wskocz od razu do miejsca.',
        prediction: 'Prognoza',
        catches: 'Połowy',
        weather: 'Pogoda',
      },
    },
    features: {
      heading: 'Co możesz robić?',
      freaks: { title: 'Freaks', description: 'Twórz i dołączaj do wydarzeń — planuj, nagrywaj i dziel się przygodami.' },
      places: { title: 'Miejsca', description: 'Odkrywaj i zapisuj trasy off-road, łowiska, stoki narciarskie i więcej.' },
      hub: { title: 'FreakHub', description: 'Dołącz do grup społecznościowych skupionych wokół Twoich ulubionych aktywności.' },
      tracker: { title: 'GPS Tracker', description: 'Nagrywaj trasy z bieżącymi statystykami: dystans, prędkość, wysokość, kalorie i tętno.' },
      shake: { title: 'Shake It', description: 'Wstrząśnij telefonem raz dziennie i miej szansę wygrać nagrody.' },
      campaigns: { title: 'Kampanie', description: 'Bierz udział w wydarzeniach partnerskich i markowych zawodach outdoorowych.' },
      theFreaks: { title: 'The Freaks', description: 'Codzienna gra dla Twojej aktywności: misje, wyzwania, codzienna nagroda i ranking Top Freaks — w przeglądarce i w aplikacji.' },
    },
    contexts: {
      heading: 'Jedna aplikacja, 25+ aktywności',
      subline: 'Przełącz kontekst w sekundę i skup się na tym, co kochasz.',
      list: [
        'Wild Off Road', 'Rowery', 'Wędkarstwo', 'Wycieczka', 'Fitness', 'Bieganie', 'Zwierzaki', 'Gry',
        'Książki', 'Jedzenie', 'Zakupy', 'Tech', 'Motoryzacja', 'Ogrodnictwo', 'Muzyka', 'Sport',
        'Sporty zimowe', 'Jeździectwo', 'Filmy', 'Seriale', 'Deskorolka', 'Rolki',
        'Hulajnoga', 'BMX', 'Grzybobranie', 'Nordic Walking',
      ],
    },
    social: {
      heading: 'Społeczność zbudowana wokół pasji',
      follow: 'Obserwuj i bądź obserwowany',
      react: 'Lajkuj i komentuj Freaki',
      chat: 'Czat w czasie rzeczywistym',
      notifications: 'Powiadomienia push',
      leaderboard: 'Ranking Top Freaks',
    },
    platforms: {
      heading: 'Dostępne wszędzie',
      web: 'Web',
      mobile: 'iOS i Android',
      watch: 'Apple Watch',
      watchNote: 'W trakcie realizacji',
      requestAccess: 'Poproś o dostęp',
    },
    explore: {
      heading: 'Ciekaw? Najpierw zajrzyj.',
      subline: 'Bez rejestracji — przeglądaj prawdziwe publiczne treści i zobacz, co tworzy społeczność.',
      freaks: {
        title: 'Przeglądaj publiczne Freaki',
        description: 'Zobacz prawdziwe przygody, wydarzenia i aktywności udostępnione przez społeczność Freakland.',
        button: 'Eksploruj Freaki',
      },
      places: {
        title: 'Odkryj publiczne Miejsca',
        description: 'Przeglądaj miejsca dodane przez społeczność — trasy, łowiska, stoki i nie tylko.',
        button: 'Eksploruj Miejsca',
      },
    },
    cta: {
      heading: 'Gotowy dołączyć?',
      register: 'Utwórz darmowe konto',
      loginPrompt: 'Masz już konto?',
      login: 'Zaloguj się',
    },
    usersCounter: {
      label: 'Zarejestrowanych Freaks',
      subline: 'i rośniemy każdego dnia',
    },
    install: {
      heading: 'Zawsze pod ręką',
      subline: 'Dodaj Freakland do ekranu głównego i uruchamiaj jak natywną aplikację — bez sklepu z aplikacjami.',
      benefit1: 'Błyskawiczny dostęp z ekranu głównego',
      benefit2: 'Pełnoekranowe doświadczenie bez paska przeglądarki',
      benefit3: 'Działa offline dla zapisanych treści',
      benefit4: 'Powiadomienia push dla Twoich przygód',
      iosHeading: 'iPhone i iPad',
      iosStep1: 'Otwórz tę stronę w Safari',
      iosStep2: 'Kliknij ikonę Udostępnij na dole ekranu',
      iosStep3: 'Wybierz „Dodaj do ekranu głównego"',
      androidHeading: 'Android',
      androidStep1: 'Otwórz tę stronę w Chrome',
      androidStep2: 'Kliknij menu (⋮) w prawym górnym rogu',
      androidStep3: 'Wybierz „Dodaj do ekranu głównego"',
      cta: 'Dodaj do ekranu głównego',
    },
    blasts: {
      heading: 'Blasty',
      subline: 'Krótkie pionowe filmiki przypisane do Freaks i miejsc — surowe chwile z trasy, wody lub stoku, nagrane i udostępnione w kilka sekund.',
      feature1Title: 'Nagrywaj w biegu',
      feature1Desc: 'Nagraj i dołącz blast bezpośrednio z Freaka lub miejsca. Bez montażu — tylko surowa przygoda.',
      feature2Title: 'Pełnoekranowy feed',
      feature2Desc: 'Przewijaj blasty całej społeczności w pionowym feedzie w stylu TikToka. Lajkuj, obserwuj i odkrywaj.',
      feature3Title: 'Zostaje z kontekstem',
      feature3Desc: 'Każdy blast jest powiązany z konkretnym Freakm lub miejscem, więc zawsze wiesz, gdzie to się wydarzyło.',
      cta: 'Oglądaj Blasty',
    },
    earlyAccess: {
      heading: 'Nagrywanie tras GPS',
      chip: 'Wczesny dostęp',
      subline: 'Nagrywaj trasy w czasie rzeczywistym — dystans, prędkość, wysokość i czas ruchu. Dostępne dla wybranych użytkowników w fazie wczesnego dostępu.',
      howTitle: 'Jak uzyskać dostęp',
      step1: 'Wyślij e-mail na adres freakland.app@gmail.com',
      step2: 'Temat: „Prośba o dostęp do tras"',
      step3: 'Podaj swój zarejestrowany adres e-mail',
      cta: 'Poproś o dostęp',
    },
    partnership: {
      heading: 'Współpracuj z Freakland',
      subline: 'Zostań rozpoznawalną twarzą swojego kontekstu aktywności lub rozwiń markę wśród tysięcy pasjonatów outdooru.',
      ambassador: {
        title: 'Ambasador Kontekstu',
        description: 'Jesteś TĄ osobą w swojej społeczności off-road, wędkarskiej lub kolarskiej? Reprezentuj swój kontekst na Freakland — zyskaj przypięty profil, weryfikację i rosnącą widownię.',
        perks: [
          'Wyróżnienie na stronie kontekstu',
          'Znaczek zweryfikowanego ambasadora',
          'Zwiększona widoczność treści',
          'Priorytet w rankingu',
        ],
        giftsNote: 'Ambasadorzy otrzymują ekskluzywne upominki i fizyczne nagrody z czasem. Sprawdzaj regularnie swój profil, żeby zobaczyć, co dla Ciebie przygotowaliśmy.',
        cta: 'Aplikuj jako ambasador',
      },
      brand: {
        title: 'Partnerstwo z marką',
        description: 'Połącz swoją markę ze społecznością aktywności. Sponsoruj nagrody Shake It, prowadź branded kampanie, dodaj swój sklep i dotrzyj do targetowanej widowni outdoorowej.',
        perks: [
          'Sponsoring nagród Shake It',
          'Kampanie i wydarzenia z marką',
          'Listing sklepu i produktów',
          'Dotarcie do swojej niszy',
        ],
        cta: 'Porozmawiajmy',
      },
      contactPrompt: 'Pytania? Napisz do nas:',
      feedbackPrompt: 'Masz przemyślenia na temat aplikacji?',
      feedbackLink: 'Wyślij nam opinię',
    },
    support: {
      heading: 'Podoba Ci się Freakland?',
      subline: 'Freakland tworzy mały zespół outdoorowych freaków. Jeśli lubisz to, co robimy, postaw nam kawę — dzięki temu serwery działają, a nowe funkcje powstają.',
      cta: 'Postaw mi kawę',
    },
  },
};

export default aboutTranslations;
